import { render, staticRenderFns } from "./CookDashboard.vue?vue&type=template&id=221a85e8&scoped=true&"
import script from "./CookDashboard.vue?vue&type=script&lang=js&"
export * from "./CookDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CookDashboard.vue?vue&type=style&index=0&id=221a85e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221a85e8",
  null
  
)

export default component.exports